export enum IdentityTypeEnum {
  Individual = 'I',
  Corporate = 'C',
}
